import { createContext } from "react";

export const usPrivacyRegulationContext = createContext(null);
 